import Triangle from "./triangle";

export default class Controller {

	constructor() {
		this.animAmt = 0;

		this.triangles = [];
		const numTriangles = 10;
		for (let i = (numTriangles - 1); i >= 0; i --) {
			let triangle = new Triangle(
				/* size= */ 22 * (i+0.5),
				/* fill= */ i % 2 == 0 ? '#FFF' : '#000',
				/* period= */ 1 / (numTriangles - i)
			)
			this.triangles.push(triangle);
		}
	}

	update(dt) {
		this.animAmt += 0.1 * dt;
		this.animAmt %= 1;
	}

	render(context) {
		this.triangles.forEach(
			triangle => triangle.render(context, this.animAmt));
	}

}



// WEBPACK FOOTER //
// ./js/controller.js